import { CustomerInputSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const UpdateCustomerChildrenResponseSchema = oz.object({
  customerChildren: oz.array(CustomerInputSchema),
});

export type UpdateCustomerChildrenResponse = oz.infer<typeof UpdateCustomerChildrenResponseSchema>;